import React, { useState, useRef } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import webBgPoster from '../../assets/webbg.png';
import webBgVideo from '../../assets/webbg.mp4';
import styles from './styles.module.scss';

interface Props {
    children: React.ReactNode;
    title?: string;
    showTitle?: boolean;
    showFooter?: boolean;
}

const PageLayout = ({ children, title, showTitle = true, showFooter = true }: Props) => {
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);

    const handleVideoReady = () => {
        if (videoRef.current) {
            videoRef.current.playbackRate = 0.5;
        }
        setIsVideoLoaded(true);
    };

    return (
        <div className={styles.pageLayout}>
            {/* Background Media: shows webbg.png immediately, then transitions to looping webbg.mp4 upon load */}
            <div className={styles.bgMediaContainer} aria-hidden="true">
                <img
                    src={webBgPoster}
                    alt=""
                    className={`${styles.bgMediaImage} ${isVideoLoaded ? styles.isHidden : ''}`}
                />
                <video
                    ref={videoRef}
                    className={`${styles.bgMediaVideo} ${isVideoLoaded ? styles.isLoaded : ''}`}
                    autoPlay
                    loop
                    muted
                    playsInline
                    disablePictureInPicture
                    poster={webBgPoster}
                    onCanPlay={handleVideoReady}
                    onPlaying={handleVideoReady}
                >
                    <source src={webBgVideo} type="video/mp4" />
                </video>
            </div>

            {/* Ambient Glow Background */}
            <div className={styles.bgAmbient} aria-hidden="true" />

            <div className={styles.contentWrapper}>
                <Header />
                <main className={styles.mainContent}>
                    {showTitle && title && <h1 className={styles.pageTitle}>{title}</h1>}
                    {children}
                </main>
                {showFooter && <Footer />}
            </div>
        </div>
    );
};

export default PageLayout;

